import React from 'react';

import { useHeroContext } from '@/modules/corporate/components/DetailPageComponents/DetailHero/context';

import { HeroComposition } from '../../types';
import BaseDateStamp from './BaseDateStamp';

const DateStamp: HeroComposition['DateStamp'] = ({ className, overrides }) => {
  const {
    content: { startDate },
  } = useHeroContext();

  if (!startDate) {
    return null;
  }

  return <BaseDateStamp className={className} date={startDate} overrides={overrides} />;
};

export default DateStamp;
